import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 70px - 158px)', // minus header and bar
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('xl')]: {
      paddingTop: theme.spacing(1),
    },
  },
  emptyBookContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    height: 'calc(100vh - 289px)',
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        height: 'initial',
      }),
    },
  },
  emptyAddressBook: {
    marginBottom: theme.spacing(5),
    width: 540,
    [theme.breakpoints.down('md')]: {
      width: 290,
    },
  },
  emptyAddressBookButton: {
    minHeight: 46,
    [theme.breakpoints.down('lg')]: {
      width: 170,
      minHeight: 44,
    },
  },
}));
